import React from 'react';
import { useSelector } from 'react-redux';
import { Navigate } from 'react-router-dom';
import { RootState } from '../store';
import { AuthState } from '../store/auth/types';

interface WithAuthProps {}

const withAuth = <P extends object>(Component: React.ComponentType<P>) => {
    const WithAuth: React.FC<P & WithAuthProps> = ({ ...props }) => {
        const { user } = useSelector<RootState, AuthState>((state) => state.auth);
        if (!user) {
            return <Navigate to="/login" replace />;
        }
        return <Component {...(props as P)} />;
    };
    return WithAuth;
};

export default withAuth;
